import { reducer } from 'redux-form';

export interface IFormState {
}

export default reducer;


// WEBPACK FOOTER //
// ./src/bundles/form/reducers/form.ts